// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2De-B","col":"styles_col__1aCyS","fulfillmentStatus":"styles_fulfillmentStatus__3aRZl","emailCol":"styles_emailCol__u9pSD"};